module.exports = __webpack_public_path__ + "img/fbt-iocn04.2aab1088.svg";